import { RouteComponentProps, Redirect } from "react-router-dom";
import React, { useState, useEffect, useCallback } from "react";
import { Loading } from "@alm/flow-ds/components";
import { useDispatch } from "react-redux";
import { createAlertAction } from "data/app/appActions";
import { createAlert } from "records/Alert";
import api from "lib/api";
import { useTranslation } from "react-i18next";
import { getErrorMessage } from "lib/api/errors";
import DashboardLayout from "components/Layouts/DashboardLayout";
import axios from "axios";

interface RouteProps {
	id: string;
}

type Props = RouteComponentProps<RouteProps>;

function ClaimTask(props: Props) {
	const { t } = useTranslation();
	const [redirect, setRedirect] = useState("");
	const id = props.match.params.id;
	const dispatch = useDispatch();

	const handleClaim = useCallback(async () => {
		try {
			api.workflow.claimTask(id).then(() => {
				setRedirect(`/task/${id}`);
			});
		} catch (error) {
			if (error && axios.isAxiosError(error)) {
				const errorMessage = getErrorMessage(error);
				dispatch(
					createAlertAction(
						createAlert({
							title: t("alerts.claimTaskError.title"),
							description:
								errorMessage !== undefined
									? `${t(
											"alerts.claimTaskError.description",
											{ id: id }
									  )}: ${errorMessage}`
									: t("alerts.claimTaskError.description", {
											id: id,
									  }),
							status: "error",
						})
					)
				);
			}
			setRedirect("/tasks/open-tasks");
		}
	}, [dispatch, id, t]);

	useEffect(() => {
		handleClaim();
		// TODO: fix this eslint stuff globally
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (redirect !== "") return <Redirect push to={redirect} />;

	return (
		<DashboardLayout>
			<Loading className="elem__loader--lg mt-5" />
		</DashboardLayout>
	);
}

export default ClaimTask;
